module.exports = {
    "source_code": "HLXEMS",
    "site_id": "discovery.cty.jhu.edu",
    "title": "Johns Hopkins Center for Talented Youth",
    "tfn": "",
    "url": "https://discovery.cty.jhu.edu",
    "gtm_code": "GTM-WXP2HG",
}